import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, Menu, X } from "lucide-react";

const MENU_LINKS = [
  { id: "home", label: "Home" },
  { id: "tools", label: "Our Tools" },
  { id: "about", label: "About Proxima" },
  { id: "contact", label: "Contact" },
];

const PageHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="relative z-20 mx-auto flex max-w-[1600px] items-center justify-between px-6 py-6 md:px-12">
        <Link to="/" data-testid="page-logo-link" className="group flex items-center gap-3" aria-label="Proxima Centauri Tools — home">
          <img
            src="/logo.png"
            alt="Proxima Centauri Tools logo"
            className="h-16 w-16 object-cover transition-[filter] duration-500 group-hover:drop-shadow-[0_0_14px_rgba(230,0,0,0.7)] md:h-20 md:w-20"
          />
          <span className="hidden flex-col leading-none sm:flex">
            <span className="font-display text-2xl font-semibold uppercase tracking-wider text-white">Proxima Centauri</span>
            <span className="font-display text-base uppercase tracking-[0.5em] text-ember">Tools</span>
          </span>
        </Link>
        <Link
          to="/"
          data-testid="page-back-link"
          className="group hidden items-center gap-2 font-display text-lg uppercase tracking-[0.18em] text-ash transition-colors duration-300 hover:text-white md:flex"
        >
          <ArrowLeft size={18} className="text-ember transition-transform duration-300 group-hover:-translate-x-1" />
          Back To Site
        </Link>
        <button
          data-testid="page-mobile-menu-open"
          onClick={() => setMenuOpen(true)}
          aria-label="Open menu"
          className="flex h-11 w-11 items-center justify-center border border-white/10 bg-coal/40 backdrop-blur-md md:hidden"
        >
          <Menu size={22} className="text-white" />
        </button>
      </header>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            data-testid="page-mobile-menu"
            className="fixed inset-0 z-[100] flex flex-col bg-coal/95 backdrop-blur-2xl"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex items-center justify-between px-6 py-6">
              <img src="/logo.png" alt="Proxima Centauri Tools logo" className="h-16 w-16 object-cover" />
              <button
                data-testid="page-mobile-menu-close"
                onClick={() => setMenuOpen(false)}
                aria-label="Close menu"
                className="text-white"
              >
                <X size={28} />
              </button>
            </div>
            <nav className="flex flex-1 flex-col justify-center gap-2 px-8" aria-label="Mobile">
              {MENU_LINKS.map((link, i) => (
                <motion.div
                  key={link.id}
                  initial={{ y: 40, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.08 + i * 0.07, duration: 0.5, ease: [0.33, 1, 0.68, 1] }}
                >
                  <Link
                    data-testid={`page-mobile-nav-${link.id}`}
                    to={`/#${link.id}`}
                    onClick={() => setMenuOpen(false)}
                    className="block text-left font-display text-6xl font-semibold uppercase leading-[1.05] text-white/90"
                  >
                    <span className="mr-3 text-xl text-ember">0{i + 1}</span>
                    {link.label}
                  </Link>
                </motion.div>
              ))}
            </nav>
            <p className="px-8 pb-10 font-body text-xs uppercase tracking-[0.3em] text-ash">
              Tools Built From Real Jobsite Problems
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default PageHeader;
